import ChromeIcon from '@/assets/icon/chrome.svg?react'
import ClaudeIcon from '@/assets/icon/claude.svg?react'
import DownloadIcon from '@/assets/icon/download.svg?react'
import FreeIcon from '@/assets/icon/free.svg?react'
import GeminiIcon from '@/assets/icon/gemini.svg?react'
import GoogleIcon from '@/assets/icon/google.svg?react'
import GptIcon from '@/assets/icon/gpt.svg?react'
import GptIconBlack from '@/assets/icon/gpt-black.svg?react'
import HomeIcon from '@/assets/icon/home.svg?react'
import Lightning from '@/assets/icon/lightning.svg?react'
import LlamaIcon from '@/assets/icon/llama.svg?react'
import LogoIcon from '@/assets/icon/logo.svg?react'
import LogoCircleIcon from '@/assets/icon/logo-circle.svg?react'
import LogoRectIcon from '@/assets/icon/logo-rect.svg?react'
import LogoutIcon from '@/assets/icon/logout.svg?react'
import OpenLinkIcon from '@/assets/icon/open-link.svg?react'
import ProIcon from '@/assets/icon/pro.svg?react'
import RightArrowIcon from '@/assets/icon/right-arrow.svg?react'
import SettingIcon from '@/assets/icon/setting.svg?react'
import ShareIcon from '@/assets/icon/share.svg?react'
import UnlimitedIcon from '@/assets/icon/unlimited.svg?react'
// 自动生成图标映射表
const IconMap = {
  gpt: GptIcon,
  gptBlack: GptIconBlack,
  claude: ClaudeIcon,
  unlimited: UnlimitedIcon,
  gemini: GeminiIcon,
  llama: LlamaIcon,
  pro: ProIcon,
  free: FreeIcon,
  logo: LogoIcon,
  google: GoogleIcon,
  chrome: ChromeIcon,
  logoCircle: LogoCircleIcon,
  lightning: Lightning,
  logoRect: LogoRectIcon,
  setting: SettingIcon,
  logout: LogoutIcon,
  home: HomeIcon,
  rightArrow: RightArrowIcon,
  openLink: OpenLinkIcon,
  share: ShareIcon,
  download: DownloadIcon,
}

interface IconProps {
  type: keyof typeof IconMap // 图标类型
}

const Icon: React.FC<IconProps> = ({ type }) => {
  const SvgIcon = IconMap[type]

  return <SvgIcon />
}

export default Icon
